import { BlockDirectionType } from '@/version-types';

export const BlockDirectionMap: Record<BlockDirectionType, BlockDirectionType> = {
    left: 'left',
    right: 'right',
    up: 'up',
    down: 'down',
};

export const SMART_GUIDE_EVENT_NAMES = {
    SET_BLOCKS: 'set-smart-blocks',
    SET_LINES: 'set-smart-lines',
};

export const MOVING_ABSORB_DISTANCE = 2;
export const RESIZING_ABSORB_DISTANCE = 2;
export const SCALE_ABSORB_DISTANCE = 2;
